export * from './angular4-events.service';
export * from './angular4-events.module';